import React, { useEffect, useState } from "react";
import styled from "styled-components";
import avatar from "assets/images/avatar.png";
import { BsThreeDots, BsPeopleFill } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import { Dropdown, IconButton } from "components/buttons/Buttons";
import PostHeader from "./PostHeader";
import PostBody from "./PostBody";
import PostActionButtons, { PostCommentBox } from "./PostActionButtons";
import PostCards from "./PostCards";

const Post = () => {
  return (
    <div className="rounded-lg bg-gray-700 p-2 ">
      <div className="flex justify-between">
        <PostHeader
          image={avatar}
          postProviderGroup="Post Provider group title"
          postProvider={"Jhon Wick"}
          time="5h"
          privacyIcon={<BsPeopleFill />}
        />
        <div className="flex ">
          <span className="text-gray-400 text-xl mr-2 cursor-pointer hover:bg-gray-500 hover:text-gray-200 h-6 p-1 rounded-sm">
            <BsThreeDots />
          </span>
          <span className="text-gray-400 text-xl mr-2 cursor-pointer hover:bg-gray-500 hover:text-gray-200 h-6 p-1 rounded-sm">
            <IoIosClose />
          </span>
        </div>
      </div>
      <PostBody />
      <PostActionButtons />
      <div className="flex justify-end items-center">
        <Dropdown />
      </div>
      <PostCommentBox avatar={avatar} />
      <PostCards
        avatar={avatar}
        commentWriter="Bruce Lee"
        comment="Stop coping my moves!!! 😤"
      />
      <PostCards
        avatar={avatar}
        commentWriter="Bruce Lee"
        comment="In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content."
      />
    </div>
  );
};

export default Post;
